<article class="product-card">
  <a [routerLink]="'/product/' + product.id" class="product-card__image-link">
    <div class="product-card__image-wrap">
      <div class="product-card__badges">
        <span class="product-card__badge product-card__badge--out" *ngIf="isOutOfStock">{{ 'product.out_of_stock' | t }}</span>
        <span class="product-card__badge" *ngIf="product.discountPrice">{{ 'product.special_offer' | t }}</span>
        <span class="product-card__badge product-card__badge--new" *ngIf="isNew">{{ 'catalog.new' | t }}</span>
        <span class="product-card__badge product-card__badge--shipping" *ngIf="product.offersFreeShipping">{{ 'product.free_shipping' | t }}</span>
        <span class="product-card__badge product-card__badge--tag" *ngIf="tagLabel" dir="auto">{{ tagLabel }}</span>
      </div>

      <div class="product-card__toolbar" role="group" [attr.aria-label]="'product.quick_view' | t">
        <button
          type="button"
          class="product-card__tool product-card__tool--preview"
          [attr.aria-label]="'product.quick_view' | t"
          (click)="onQuickPreview($event)">
          <img src="/assets/icons/figma/eye-preview.svg" alt="" aria-hidden="true" />
        </button>
        <button
          *ngIf="showCompare"
          type="button"
          class="product-card__tool product-card__tool--compare"
          [class.product-card__tool--active]="inCompare"
          [attr.aria-pressed]="inCompare"
          [attr.aria-label]="'product.compare_add' | t"
          (click)="onCompareClick($event)">
          <img src="/assets/icons/figma/compare.svg" alt="" aria-hidden="true" />
        </button>
        <button
          *ngIf="showWishlist"
          type="button"
          class="product-card__tool product-card__tool--wish"
          [class.product-card__tool--active]="inWishlist"
          [disabled]="wishlistBusy"
          [attr.aria-pressed]="inWishlist"
          [attr.aria-label]="(inWishlist ? 'product.wishlist_remove' : 'product.wishlist_add') | t"
          (click)="onWishlistClick($event)">
          <img src="/assets/icons/figma/wishlist.svg" alt="" aria-hidden="true" />
        </button>
      </div>

      <app-media-slot fit="contain">
        <img
          [appMediaSrc]="product.imageUrl || ''"
          appMediaPlaceholder="/assets/placeholder.svg"
          appMediaProfile="card"
          [appMediaProgressive]="false"
          [appMediaSharp]="true"
          [appMediaPriority]="false"
          [attr.fetchpriority]="null"
          [alt]="product | productDisplayName"
          loading="lazy"
          decoding="async" />
      </app-media-slot>
    </div>
  </a>
  <div class="product-card__body">
    <h4 class="product-card__title">
      <a [routerLink]="'/product/' + product.id" [attr.title]="product | productDisplayName">
        <span class="product-card__title-text" dir="auto">{{ product | productDisplayName }}</span>
      </a>
    </h4>
    <p class="product-card__category" *ngIf="product.categoryName">
      <span class="product-card__category-text" dir="auto">{{ product.categoryName | categoryName: product.categoryNameEn : product.categoryNameAr }}</span>
    </p>
    <div class="product-card__price">
      <span class="product-card__price-current">{{ product.discountPrice || product.price | currency: 'EGP' }}</span>
      <span class="product-card__price-old" *ngIf="product.discountPrice">{{ product.price | currency: 'EGP' }}</span>
    </div>
    <p class="product-card__stock product-card__stock--out" *ngIf="isOutOfStock">{{ 'product.out_of_stock' | t }}</p>
  </div>
  <div class="product-card__actions">
    <button
      class="btn btn-primary btn-pill"
      [class.is-added]="recentlyAdded && !isOutOfStock"
      [class.is-out-of-stock]="isOutOfStock"
      type="button"
      (click)="onAddToCart($event)">
      {{ buttonLabel }}
    </button>
    <button
      *ngIf="!isOutOfStock"
      class="btn btn-buy-now btn-pill"
      type="button"
      (click)="onBuyNow($event)">
      {{ 'product.buy_now' | t }}
    </button>
  </div>
</article>
